import React, { useEffect } from 'react'
import qs from 'qs'
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { selectCurrentStore } from '../reducers/storeSlice'
import UtmUtils from '../utils/utmUtils'
import { GJLogo, LiveShopping } from '../components/GJKit/newGJLogo'
import { Survey } from '../components/GJKit/Survey/Survey'
import { useAuth } from '@gojiraf/auth'
import { CustomerRoles } from '../constants/customerRoles'
import { useUtm } from '@gojiraf/useutm'
import { BackgroundImageWithFallback } from '../components/BackgroundImageWithFallback'
import fallbackBackground from '../../assets/fallback_background.jpeg'
import { useEventById } from '../hooks/use-event-by-id'
import { TopNavBar } from '../components/Call/TopNavBar'
import styled from 'styled-components'

export function FinishedEventSurvey() {
  const { data: event } = useEventById()
  const { user } = useAuth()
  const params = useParams()
  const queryParams = qs.parse(window.location.search, { ignoreQueryPrefix: true })
  const { utm_medium } = UtmUtils.getUtmObject(queryParams)
  const { showUIComponents } = useUtm(utm_medium)
  const store = useSelector(selectCurrentStore)
  const showSurvey = user.role === CustomerRoles.BUYER && showUIComponents
  const navigate = useNavigate()
  const location = useLocation()
  const [searchParams] = useSearchParams()
  const isIframe = searchParams.get('iframe') === 'true'

  useEffect(() => {
    if (store == null) {
      UtmUtils.navigateWithUTM({ path: `store/${params.storeId}`, navigate, location })
    }
  }, [])

  return (
    <BackgroundImageWithFallback
      desktop={event?.images?.['countdown-desktop']}
      mobile={event?.images?.['countdown-mobile']}
      fallback={fallbackBackground}
    >
      {isIframe && (
        <NavBarContainer>
          <TopNavBar isIframe={isIframe} />
        </NavBarContainer>
      )}
      <LogoContainer>
        <LiveShopping />
        <GJLogo />
      </LogoContainer>
      {store && showSurvey && <Survey />}
    </BackgroundImageWithFallback>
  )
}

const LogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
`
const NavBarContainer = styled.div`
  position: absolute;
  top: 1rem;
  right: 0.5rem;
  display: flex;
  justify-content: flex-end;
  z-index: 10;
`
